// extracted by mini-css-extract-plugin
module.exports = {"project__content":"solution-section_project__content__73taW","project__text":"solution-section_project__text__9lUvN"};